import React, { createContext, useContext } from 'react'

import { cookieAllowlist } from '../config/cookie-allowlist'
import { exists } from '~/utils/array'
import { filterObjectKeys } from '~/utils/objects'

const AppContext = createContext({})

const AppProvider = ({
  children,
  value: {
    cookies = {},
    cleanQueryString = {},
    evCore = {},
    experiences = {},
    device = 'mobile',
    comparisonId = '',
    isPersonalisedResults = false,
    isServer = false,
    isMobileApp = false,
    ...rest
  }
}) => {
  const filteredCookies = filterObjectKeys(exists(cookieAllowlist), cookies)

  return (
    <AppContext.Provider
      value={{
        cleanQueryString,
        evCore,
        experiences,
        device,
        comparisonId,
        isPersonalisedResults,
        isServer,
        isMobileApp,
        cookies: filteredCookies,
        ...rest
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => {
  const appContext = useContext(AppContext)

  return appContext
}

export { AppProvider, useContext }
